export const NOTE_LIST_GENERIC_ACTIVITY_LIST_SORT = 'NOTE_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const NOTE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'NOTE_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
